import regexps from './regexps';
import masks from './masks.json';

const defaultFields = {
    address: {
        id: 'address',
        label: 'Endereço residencial',
        required: true,
        type: 'text',
        mask: 'b'.repeat(9999),
        requiredMessage: 'Adicione um endereço válido',
    },
    addressNumber: {
        id: 'addressNumber',
        label: 'Nº',
        regex: regexps.noSpaces,
        mask: '*'.repeat(999),
        required: true,
        type: 'text',
        requiredMessage: 'Digite um número de endereço válido',
    },
    admissionDate: {
        id: 'admissionDate',
        label: 'Data de admissão',
        required: true,
        type: 'date',
        requiredMessage: 'Preencha a data de admissão',
    },
    birth: {
        id: 'birth',
        label: 'Data de nascimento',
        required: true,
        type: 'date'
    },
    birthUser: {
        id: 'birthUser',
        label: 'Data de nascimento',
        required: false,
        type: 'date'
    },
    capacity: {
        id: 'capacity',
        label: 'Lotação',
        required: true,
        type: 'select',
        options: [],
    },
    cardNumber: {
        id: 'cardNumber',
        label: 'Carteirinha',
        required: false,
        type: 'text',
    },
    cellphone: {
        id: 'cellphone',
        label: 'Telefone celular',
        mask: masks.cellphone,
        required: true,
        type: 'text',
        requiredMessage: 'Digite um telefone com o DDD válido',
    },
    cep: {
        id: 'cep',
        label: 'CEP',
        mask: masks.cep,
        required: true,
        type: 'text',
        requiredMessage: 'Digite um CEP válido',
    },
    cid: {
        id: 'cid',
        label: 'CID',
        help: 'Classificação internacional de doenças.',
        required: false,
        placeholder: 'Digite um código',
    },
    city: {
        id: 'city',
        label: 'Cidade',
        required: true,
        type: 'select',
        options: [],
        requiredMessage: 'Selecione a cidade',
    },
    civilState: {
        id: 'civilState',
        label: 'Estado civil',
        required: true,
        type: 'select',
        options: [],
        requiredMessage: 'Selecione o estado civil',
    },
    company: {
        id: 'company',
        label: 'Empresa',
        required: true,
        type: 'select',
        options: [],
        requiredMessage: 'Selecione a empresa',
    },
    contracts: {
        id: 'contracts',
        label: 'Contrato',
        required: true,
        placeholder: 'Selecione',
        type: 'select',
        options: [],
    },
    congenerCardNumber: {
        id: 'congenerCardNumber',
        label: 'Nº da carteirinha',
        type: 'text',
        required: true,
    },
    congenerName: {
        id: 'congenerName',
        label: 'Congênere',
        type: 'text',
        value: '',
        disabled: true,
    },
    congener: {
        id: 'congener',
        label: 'Congênere',
        required: true,
        placeholder: 'Selecione',
        type: 'select',
        options: [],
    },
    complement: {
        id: 'complement',
        label: 'Complemento',
        required: false,
        type: 'text',
        mask: '*'.repeat(999),
    },
    contractName: {
        id: 'contractName',
        label: 'Nome contrato',
        required: false,
        type: 'text',
    },
    costCenter: {
        id: 'costCenter',
        label: 'Centro de custo',
        help: 'Setor responsável pelo controle financeiro da empresa.',
        required: false,
        type: 'select',
        options: [],
    },
    countyService: {
        id: 'countyService',
        label: 'Município de atendimento',
        required: true,
        type: 'select',
        options: [],
    },
    contractSize: {
        id: 'contractSize',
        label: 'Porte do contrato',
        required: false,
        type: 'text',
    },
    contractType: {
        id: 'contractType',
        label: 'Tipo do contrato',
        required: false,
        type: 'text',
    },
    costCenterCode: {
        id: 'costCenterCode',
        label: 'Código do centro de custo',
        help: '',
        mask: '*'.repeat(30),
        required: true,
        type: 'text',
        requiredMessage: '',
    },
    costCenterName: {
        id: 'costCenterName',
        label: 'Nome do centro de custo',
        help: '',
        mask: 'b'.repeat(50),
        required: true,
        type: 'text',
        requiredMessage: '',
    },
    costCenterInitials: {
        id: 'costCenterInitials',
        label: 'Sigla do centro de custo',
        help: '',
        mask: '*'.repeat(15),
        required: false,
        type: 'text',
        requiredMessage: '',
    },
    costCenterResponsible: {
        id: 'costCenterResponsible',
        label: 'Pessoa responsável',
        help: '',
        mask: 'b'.repeat(50),
        required: false,
        type: 'text',
        requiredMessage: '',
    },
    comercialPhone: {
        id: 'comercialPhone',
        label: 'Telefone comercial',
        help: '',
        mask: masks.phone,
        required: false,
        type: 'text',
        requiredMessage: '',
    },
    cpf: {
        id: 'cpf',
        label: 'CPF',
        mask: masks.cpf,
        required: true,
        type: 'text',
        requiredMessage: 'Digite um número de CPF válido',
    },
    cpfAndCnpj: {
        id: 'cpfAndCnpj',
        label: 'CNPJ ou CPF',
        mask: masks.cpf,
        required: true,
        type: 'text',
        requiredMessage: 'O CNPJ/CPF informado é inválido ou a empresa está inativa.',
    },
    contractNumber: {
        id: 'cpfAndCnpj',
        label: 'CNPJ ou CPF',
        mask: masks.cpf,
        required: true,
        type: 'text',
        requiredMessage: 'O CNPJ/CPF informado é inválido ou a empresa está inativa.',
    },
    dateStartPlan: {
        id: 'dateStartPlan',
        label: 'Data de início do plano',
        help: 'Data sugerida pelo sistema. Alterar a data de início gera cobrança do valor integral do plano na próxima fatura.',
        required: true,
        type: 'date',
        requiredMessage: 'Preencha a data de início do plano',
    },
    dismissalDate: {
        id: 'dismissalDate',
        label: 'Data de demissão ou cancelamento do plano',
        help: 'Ao desligar o beneficiário, o valor proporcional do plano não será estornado.',
        required: true,
        type: 'date',
    },
    dn: {
        id: 'dn',
        label: 'Declaração de nascido vivo (DN)',
        help: 'Documento gerado pelo hospital para o registro da criança recém-nascida. Obrigatório para nascimentos após 1° de janeiro de 2010.',
        mask: '9'.repeat(11),
        required: true,
        type: 'text',
        disabled: true,
        requiredMessage: 'Adicione a declaração de nascido vivo da pessoa dependente',
    },
    email: {
        id: 'email',
        label: 'E-mail',
        regex: regexps.noSpaces,
        required: true,
        type: 'text',
        requiredMessage: 'Digite um e-mail válido',
    },
    enrollmentSequence: {
        id: 'enrollmentSequence',
        label: 'Sequencial matrícula funcional',
        help: 'Número da matrícula funcional da pessoa titular na empresa.',
        mask: '9'.repeat(8),
        required: false,
        type: 'text',
        requiredMessage: 'Preencha o sequencial da matrícula funcional',
    },
    fullName: {
        id: 'fullName',
        label: 'Nome completo',
        required: true,
        type: 'text',
        regex: regexps.lettersAndSpaces,
        requiredMessage: 'Adicione um nome e sobrenome',
    },
    functionalEnrollment: {
        id: 'functionalEnrollment',
        label: 'Matrícula funcional',
        help: 'Documento que comprova o vínculo da pessoa titular com a empresa.',
        mask: '9'.repeat(15),
        required: true,
        type: 'text',
        requiredMessage: 'Preencha a matrícula funcional',
    },
    functionalStatus: {
        id: 'functionalStatus',
        label: 'Situação funcional',
        help: 'Situação da pessoa titular na empresa: colaboradora, prestadora de serviços, aposentada etc.',
        required: false,
        type: 'select',
        options: [],
    },
    gender: {
        id: 'gender',
        label: 'Sexo',
        help: 'Referente ao órgão sexual da pessoa ao nascer.',
        required: true,
        type: 'select',
        options: [
            {
                codigo: 'M',
                nome: 'Masculino',
            },
            {
                codigo: 'F',
                nome: 'Feminino',
            },
        ],
        requiredMessage: 'Selecione o sexo',
    },
    healthPlan: {
        id: 'healthPlan',
        label: 'Plano de saúde',
        required: true,
        type: 'select',
        options: [],
        requiredMessage: 'Selecione o plano de saúde',
    },
    lackGroup: {
        id: 'lackGroup',
        label: 'Grupo de carência',
        mask: '9'.repeat(4),
        required: true,
        type: 'text',
        requiredMessage: 'Digite o número do grupo de carência',
    },
    height: {
        id: 'height',
        label: 'Altura (metros)',
        mask: masks.height,
        regex: regexps.height,
        required: true,
        type: 'text',
        requiredMessage: 'Adicione a altura da pessoa titular',
    },
    hood: {
        id: 'hood',
        label: 'Bairro',
        required: true,
        type: 'text',
        regex: regexps.lettersAndSpaces,
        requiredMessage: 'Informe o bairro',
    },
    kinshipDegree: {
        id: 'kinshipDegree',
        label: 'Grau de parentesco',
        required: true,
        type: 'select',
        options: [],
        requiredMessage: 'Selecione o grau de parentesco',
    },
    motherName: {
        id: 'motherName',
        label: 'Nome da mãe',
        required: true,
        type: 'text',
        regex: regexps.lettersAndSpaces,
        requiredMessage: 'Informe o nome da mãe da pessoa',
    },
    nationality: {
        id: 'nationality',
        label: 'Nacionalidade',
        options: [
            {
                codigo: 'B',
                nome: 'Brasileira',
            },
            {
                codigo: 'E',
                nome: 'Estrangeira',
            },
        ],
        value: 'B',
        lookup: 'Brasileira',
        required: true,
        type: 'radio',
        requiredMessage: 'Selecione a nacionalidade da pessoa titular',
    },
    occupation: {
        id: 'occupation',
        label: 'Cargo',
        required: true,
        type: 'select',
        options: [],
        requiredMessage: 'Selecione o cargo',
    },
    phone: {
        id: 'phone',
        label: 'Telefone',
        help: '',
        mask: masks.phone,
        required: true,
        type: 'text',
        requiredMessage: '',
    },
    pis: {
        id: 'pis',
        label: 'Nº do PIS',
        help: 'Número emitido pela Caixa em que a pessoa recebe os valores do FGTS.',
        mask: masks.pis,
        required: false,
        type: 'text',
    },
    ramal: {
        id: 'ramal',
        label: 'Ramal',
        help: '',
        mask: '9'.repeat(4),
        required: false,
        type: 'text',
        requiredMessage: '',
    },
    socialName: {
        id: 'socialName',
        label: 'Nome social',
        help: 'Nome que a pessoa se identifica.',
        required: false,
        type: 'text',
        regex: regexps.lettersAndSpaces,
        requiredMessage: 'Adicione o nome social',
    },
    startCapacity: {
        id: 'startCapacity',
        label: 'Início lotação',
        help: 'Data em que a pessoa titular começou em nova posição dentro da empresa (função, sede, andar etc.)',
        required: true,
        type: 'date',
        requiredMessage: 'Insira uma data válida',
    },
    startDate: {
        id: 'startDate',
        label: 'Data de início da contribuição',
        required: false,
        type: 'date',
    },
    stateService: {
        id: 'stateService',
        label: 'Estado de atendimento',
        required: false,
        type: 'select',
        options: [],
    },
    sus: {
        id: 'sus',
        label: 'Nº cartão do SUS',
        help: 'Número com 15 dígitos que está no cartão do SUS da pessoa. O cartão do SUS pode ser emitido em qualquer Unidade Básica de Saúde (UBS) do Brasil.',
        mask: masks.sus,
        required: false,
        type: 'text',
    },
    uf: {
        id: 'uf',
        label: 'UF',
        required: true,
        type: 'select',
        options: [],
        requiredMessage: 'Selecione o estado',
    },
    weddingDate: {
        id: 'weddingDate',
        label: 'Data de casamento/união estável',
        help: 'Data da união firmada em cartório.',
        required: false,
        type: 'date',
        requiredMessage: 'Adicione a data de casamento/união estável da pessoa dependente',
    },
    weight: {
        id: 'weight',
        label: 'Peso (Kg)',
        regex: regexps.weight,
        required: true,
        type: 'text',
        requiredMessage: 'Adicione o peso da pessoa titular',
    },
    pregnant: {
        id: 'pregnant',
        label: 'Gestante',
        options: [
            {
                codigo: 'S',
                nome: 'Sim',
            },
            {
                codigo: 'N',
                nome: 'Não',
            },
        ],
        value: 'N',
        required: true,
        type: 'radio',
        requiredMessage: 'Selecione uma das opções',
    },
    newborn: {
        id: 'newborn',
        label: 'Recém-Nascido',
        options: [
            {
                codigo: 'S',
                nome: 'Sim',
            },
            {
                codigo: 'N',
                nome: 'Não',
            },
        ],
        value: 'N',
        required: true,
        type: 'radio',
        requiredMessage: 'Selecione uma das opções',
    },
    requestType: {
        id: 'requestType',
        label: 'Tipo de Solicitação',
        required: true,
        type: 'text',
        options: [],
        requiredMessage: 'Selecione o tipo da solicitação',
    },
    areaRegion: {
        id: 'areaRegion',
        label: 'Área/Região',
        required: true,
        type: 'select',
        options: [],
        requiredMessage: 'Selecione a Área/Região',
    },
    surgeryDate: {
        id: 'surgeryDate',
        label: 'Data Programada Cirurgia',
        type: 'date',
        requiredMessage: 'Preencha a data de programa cirurgia',
    },
    exameLocation: {
        id: 'exameLocation',
        label: 'Local para realização do Exame/Cirurgia',
        type: 'text',
        requiredMessage: 'Informe o local para realização do Exame/Cirurgia',
    },
    note: {
        id: 'note',
        label: 'Observação',
        required: true,
        type: 'text',
        requiredMessage: 'Informe alguma observação',
    },
    establishmentName: {
        id: 'establishmentName',
        label: 'Nome do estabelecimento',
        required: true,
        type: 'text',
        requiredMessage: 'Informe algum estabelecimento',
    },
    receptionResponsible: {
        id: 'receptionResponsible',
        label: 'Responsável pelo acolhimento',
        required: true,
        type: 'text',
        requiredMessage: 'Informe algum responsável pelo acolhimento',
    },
    accidentReason: {
        id: 'accidentReason',
        label: 'Motivo do acidente',
        required: true,
        type: 'select',
        requiredMessage: 'Informe o motivo do acidente',
    },
    serviceStartDate: {
        id: 'serviceStartDate',
        label: 'Data início do atendimento',
        required: true,
        type: 'date',
        requiredMessage: 'Informe a data início do atendimento',
    },
    inclusionResponsible: {
        id: 'inclusionResponsible',
        label: 'Responsável (Inclusão)',
        required: true,
        type: 'text',
        requiredMessage: 'Informe o responsável pela inclusão',
    },
    serviceEndDate: {
        id: 'serviceEndDate',
        label: 'Data fim do atendimento',
        required: true,
        type: 'date',
        requiredMessage: 'Informe a data fim do atendimento',
    },
    demissionResponsible: {
        id: 'demissionResponsible',
        label: 'Responsável (Desligamento)',
        required: false,
        type: 'text',
    },
    identificationCode: {
        id: 'identificationCode',
        label: 'Código de identificação',
        required: true,
        type: 'text',
    },
    sequentialAccident: {
        id: 'sequentialAccident',
        label: 'Nº sequencial do acidente',
        help: 'Informe o número sequencial do acidente que deseja editar deste beneficiário.',
        required: true,
        type: 'number'
    },
    specialty: {
        id: 'specialty',
        label: 'Especialidade',
        required: true,
        requiredMessage: 'Informe a especialidade',
        type: 'select',
        options: [],
    },
    network: {
        id: 'network',
        label: 'Rede',
        required: true,
        type: 'select'
    },
    service: {
        id: 'service',
        label: 'Tipo Atendimento',
        type: 'select',
        required: true,
        requiredMessage: 'Informe o tipo de atendimento'
    }
};

export default defaultFields;

export const getFields = (fields) =>
    fields.reduce((obj, fieldName) => {
        const fieldObject = obj;

        fieldObject[fieldName] = defaultFields[fieldName];

        return fieldObject;
    }, {});
